import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PAY_PC, PAY} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {LocationChangeHistoryParam, ThunkApi} from '../interfaces'

const PAY_LATER_SIGN_UP_PC_URL = `${PAY_PC}/paylater/signup`
const PAY_LATER_SIGN_UP_MO_URL = `${PAY}/paylater/signup`

/**
 * 페이홈 마이페이지로 이동
 */
const navigateToPayLaterSignUp = createAsyncThunk<
    void,
    (LocationChangeHistoryParam & {inflow: 'd' | 'c2' | 'rsv' | 'pk'; rurl: string}) | void,
    ThunkApi
>('navigateTo/payHome', async (args) => {
    const {historyType = 'PUSH', inflow, rurl} = args ?? {}

    const url = qs.stringifyUrl({
        url: isMobile ? PAY_LATER_SIGN_UP_MO_URL : PAY_LATER_SIGN_UP_PC_URL,
        query: {
            inflow,
            rurl,
        },
    })

    changeBrowserLocation({url, type: historyType})
})

export default navigateToPayLaterSignUp
